/** @format */

import { END_POINT, headersFormData } from "utils";
import { deleteRequest, getRequest, postRequest } from "./axios";
import { IdForm, FormTagUpdate, FormTagStore } from "types";
import { toFormData } from "axios";

export const tagService = {
  onGetList: async (projectId, page = 1) => {
    try {
      const rs = await getRequest(`${END_POINT.PROJECTS.LIST}/${projectId}/tags?page=${page}`);
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  show: async (projectId, id) => {
    try {
      const rs = await getRequest(`${END_POINT.PROJECTS.LIST}/${projectId}/tags/${id}`);
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  store: async (payload: FormTagStore) => {
    try {
      const rs = await postRequest(`${END_POINT.PROJECTS.LIST}/${payload.project_id}/tags`, payload);
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  update: async (payload: FormTagUpdate) => {
    try {
      const rs = await postRequest(`${END_POINT.PROJECTS.LIST}/${payload.project_id}/tags/${payload.id}`, toFormData({ ...payload, '_method': 'PATCH' }), {
        headers: headersFormData,
      });
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  destroy: async (payload: IdForm) => {
    try {
      const rs = await deleteRequest(`${END_POINT.PROJECTS.LIST}/${payload.project_id}/tags/${payload.id}`);
      return rs.data;
    } catch (error) {
      return null;
    }
  },
};

